import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../config";
import SaleHeader from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import pdfStyles from "../../../Pdf/pdfStyles";
import { PrintFormateNumber } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

function PrintSaleReport() {
  const [loading, setLoading] = useState(false);

  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");
  const ProductID = urlParams.get("ProductID");
  const AccountID = urlParams.get("AccountID");
  const [data, setData] = useState([]);
  const[saleSummary,setSaleSummary]=useState([]);


  const [salesList, setSalesList] = useState([]);

  useEffect(() => {
    document.title = "Print Sale Report";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: 1,
      PageSize: 20000,
      StartDate: StartDate,
      EndDate: EndDate,
      ProductID: ProductID,
      CustomerID: AccountID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Report/GetSalesReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };


    axios(api_config)
      .then(function (response) {
   
        if (response.data.status_code == 1) {
          setSalesList(response.data.listofSales);
          setSaleSummary(response.data.SaleSummary)
          setData(response.data);

          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const generateData = () => {
    if (salesList.length > 0) {
      return salesList.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 40 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Receipt_No}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 60 }]}>
              <Text style={pdfStyles.tdValue}>
                {moment(item.Sale_Invoice_Head_BE?.Dated).format(config.date_format)}
              </Text>
            </View>
            <View style={[pdfStyles.td, { width: 100 }]}>
              <Text style={pdfStyles.tdValue}>{item.Account_BE?.Name}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={pdfStyles.tdValue}>{item.Product_BE?.Name}</Text>
            </View>
            
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Vehicle_No}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>{PrintFormateNumber(item.Price,2)}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>{PrintFormateNumber(item.Quantity,2)}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 80, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>{PrintFormateNumber(item.Amount,0)}</Text>
            </View>
          </View>
        );
      });
    }
  };

  const genrateSaleSummary = () => {
    if (saleSummary.length > 0) {
      return saleSummary.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 40 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>
           
            <View style={[pdfStyles.td, { width: 140 }]}>
              <Text style={pdfStyles.tdValue}>{item.ProductCode}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 160 }]}>
              <Text style={pdfStyles.tdValue}>{item.Name}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 110, textAlign:'right' }]}>
              <Text style={pdfStyles.tdValue}>{PrintFormateNumber(item.Balance)}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 110, textAlign:'right' }]}>
              <Text style={pdfStyles.tdValue}>{PrintFormateNumber(item.Amount,0)}</Text>
            </View>
          </View>
        );
      });
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <SaleHeader />
        <View style={pdfStyles.section}>
          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Sales Report</Text>
          </View>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 40 }]}>
                <Text style={pdfStyles.thValue}>SR.</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Receipt</Text>
              </View>
              <View style={[pdfStyles.th, { width: 60 }]}>
                <Text style={pdfStyles.thValue}>Dated</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100 }]}>
                <Text style={pdfStyles.thValue}>Customer</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80 }]}>
                <Text style={pdfStyles.thValue}>Product</Text>
              </View>
             
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Vehicle</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Price</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Quantity</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Amount</Text>
              </View>
            </View>

            {generateData()}

            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Total Sales</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>{data.TotalSales}</Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Cash Sales</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>{data.TotalCashSales}</Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Credit Sales</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>{data.TotalCreditSales}</Text>
              </View>
            </View>
          </View>

          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Sales Summary</Text>
          </View>

          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 40 }]}>
                <Text style={pdfStyles.thValue}>SR.</Text>
              </View>
              <View style={[pdfStyles.th, { width: 140 }]}>
                <Text style={pdfStyles.thValue}>Product Code</Text>
              </View>
              <View style={[pdfStyles.th, { width: 160 }]}>
                <Text style={pdfStyles.thValue}>Name</Text>
              </View>
              <View style={[pdfStyles.th, { width: 110, textAlign:'right' }]}>
                <Text style={pdfStyles.thValue}>Quantity</Text>
              </View>
              <View style={[pdfStyles.th, { width: 110, textAlign:'right' }]}>
                <Text style={pdfStyles.thValue}>Amount</Text>
              </View>
            </View>
            {genrateSaleSummary()}
            
          </View>
          <View
            style={{ marginBottom: 50, marginTop: 0, top: 10, bottom: 10 }}
            fixed
          >
            <Text
              style={{ fontSize: "8pt" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <PDFViewer width="100%" height="100%" fileName="sample.pdf">
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
}

export default PrintSaleReport;
